<template>
    <div class="svg-wrap" id='line-wrap'>
        <div class="line-cell">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1923.157 259.979">
                <g id="wave_line" transform="translate(.863 -507.258)">
                    <path id="green" d="M0 474.817s76.609-131.155 232.144-55.539 94.98 278.17 357.007 99.342 367.432-201.94 484.883-178.828 70.076 147.735 274.329 110.108 37.9 148.073 212.94 93.061 284.2-267.416 360.251-183.542" class="cls-1" data-name="Path 733" transform="translate(0 175.886)"/>
                </g>
            </svg>
        </div>
    </div>
</template>

<script>
import anime from 'animejs'
export default {
    watch: {
        slideIndex(n) {
            if(n === 0) {
                this.lineAnimate()
            } else {
                this.initLine()
            }
        }
    },
    methods: {
        initLine(){
            anime({
                targets: 'path#green',
                strokeDashoffset: anime.setDashoffset
            })
        },
        lineAnimate() {
            var animeGreen = anime({
                targets: 'path#green',
                strokeDashoffset: [anime.setDashoffset, 0],
                easing: 'linear',
                duration: 2000,
                delay: 0,
                direction: 'normal',
                loop: false
            })
        }
    },
    created(){
        this.$nextTick(() => {
            this.initLine()
            this.lineAnimate()
        })
    },
    computed: {
        slideIndex(){
            return this.$store.getters.getSlideIndex
        }
    }
}
</script>

<style>
.svg-wrap { position: absolute; z-index: -1; width: 100vw; height: 100vh; top: 0; left: 0; display: table; }
.line-cell { display: table-cell; vertical-align: middle; width: 100%; height: 100%; }
.cls-1{fill:none;stroke:#2cf388;stroke-width:2px}
</style>
